var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ElPopover",
    _vm._b(
      {
        ref: "FieldPopover",
        attrs: {
          trigger: "hover",
          "open-delay": 800,
          placement: "left-start",
          "visible-arrow": false,
          "popper-class": ["pt-ui-popover", "field-info-popover__popper"].join(
            " "
          ),
        },
        on: { show: _vm.onShow },
      },
      "ElPopover",
      _vm.$attrs,
      false
    ),
    [
      _vm._t("default", null, { slot: "reference" }),
      _c(
        "div",
        { staticClass: "field-info-header" },
        [
          _c("PtIcon", {
            style: {
              color: _vm.fieldColor,
            },
            attrs: { icon: _vm.fieldIcon },
          }),
          _c("span", { attrs: { title: _vm.field.displayName } }, [
            _vm._v(_vm._s(_vm.field.displayName)),
          ]),
        ],
        1
      ),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "loading-pane" },
            [_c("PtIcon", { attrs: { icon: "SolidLoadingBars" } })],
            1
          )
        : _c(
            "div",
            { on: { click: _vm.onTreeMounted } },
            [
              _c("PtVirtualTree", {
                ref: "wTreeCompRef",
                staticClass: "field-info-tree",
                attrs: {
                  itemClass: "node-item",
                  itemMinItemSize: 32,
                  data: _vm.fieldData,
                  nodeKey: "id",
                  defaultExpandAll: "",
                },
                on: { "hook:mounted": _vm.onTreeMounted },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var node = ref.node
                      var isShowExpandIcon = ref.isShowExpandIcon
                      var isExpand = ref.isExpand
                      var toggleNodeExpand = ref.toggleNodeExpand
                      return [
                        _c("div", {
                          style: {
                            paddingLeft:
                              (_vm.isListMode ? 0 : (node.level - 1) * 12) +
                              "px",
                          },
                        }),
                        _c(
                          "div",
                          { staticClass: "node-item__tree-icon" },
                          [
                            isShowExpandIcon && !_vm.isListMode
                              ? _c("PtIcon", {
                                  attrs: {
                                    icon: isExpand
                                      ? "SolidDropdownOpen"
                                      : "SolidDropdownRight",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return toggleNodeExpand(node)
                                    },
                                  },
                                })
                              : _c("div", { staticClass: "dot" }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "node-item__item-name" }, [
                          _vm._v(" " + _vm._s(node.data.name) + " "),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }